import { render, staticRenderFns } from "./ProductBox.vue?vue&type=template&id=1a873327&scoped=true"
import script from "./ProductBox.vue?vue&type=script&lang=js"
export * from "./ProductBox.vue?vue&type=script&lang=js"
import style0 from "./ProductBox.vue?vue&type=style&index=0&id=1a873327&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a873327",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a873327')) {
      api.createRecord('1a873327', component.options)
    } else {
      api.reload('1a873327', component.options)
    }
    module.hot.accept("./ProductBox.vue?vue&type=template&id=1a873327&scoped=true", function () {
      api.rerender('1a873327', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/ProductBox.vue"
export default component.exports